import React, { useState } from "react";
// import Header4 from "../components/Header4";
import Footer from "../components/Footer";
import Header3 from "../components/Header3";
import { Link } from "react-router-dom";

const Help = () => {
  const [alertVisible, setAlertVisible] = useState(false);

  const handleSend = (event) => {
    event.preventDefault(); // Prevent form submission default behavior
    setAlertVisible(true); // Show the alert
    window.scrollTo({ top: 0, behavior: "smooth" });

    setTimeout(() => setAlertVisible(false), 4000); // Hide the alert after 3 seconds
  };

  const handleCloseAlert = () => {
    setAlertVisible(false); // Manually close the alert
  };
  return (
    <>
      <div className=" d-flex flex-column" style={{ height: "100vh" }}>
        <Header3 />

        {alertVisible && (
          <div
            style={{
              position: "absolute", // Overlay on top
              top: "14%",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "orange",
              color: "white",
              padding: "10px 10px",
              borderRadius: "5px",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // width: "400px",
              // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              zIndex: 1000,
            }}
          >
            {/* Tick Icon */}
            <div
              style={{
                backgroundColor: "white",
                color: "green",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "10px",
                fontWeight: "bold",
                fontSize: "16px",
                border: "1px solid green",
              }}
            >
              ✓
            </div>
            <div className="fontmobil" style={{ flex: 1 }}>
              Request sent
            </div>
            {/* Close Icon */}
            <div
              style={{
                cursor: "pointer",
                marginLeft: "10px",
                color: "white",
                fontWeight: "bold",
                fontSize: "18px",
              }}
              onClick={handleCloseAlert}
            >
              ×
            </div>
          </div>
        )}
        <div className="justzomag helpmx flex-grow-1">
          <div className="mx-5 my-5 ">
            <div className="mx-sm-5 ">
              <div
                className=" fw-bold aboutauther mb-4"
                style={{ fontSize: "27px" }}
              >
                Send a request
              </div>

              <div className=" fw-normal fs-5 ftzevtt  ">
                How can we help you? Briefly describe your issue
                <span style={{ color: "#D10000" }}>*</span>
              </div>

              <textarea
                type="text"
                className="form-control my-2 w-100 hekpwid fw-normal fontmobil fs-6 bg-transparent  rounded-1 placeholder-login"
                id="text"
                style={{
                  border: "2px solid #000000",
                  maxWidth: "797px",
                  height: "232px",
                  color: "#5B5B5B",
                }}
              />

              <div className=" fw-normal fs-5 mt-4 ftzevtt ">
                Your e-mail
                <span style={{ color: "#D10000" }}>*</span>
              </div>

              <input
                type="text"
                className="form-control my-2 w-100  fw-normal fontmobil fs-6 bg-transparent  rounded-1 placeholder-login"
                id="text"
                style={{
                  border: "2px solid #000000",
                  maxWidth: "797px",
                  height: "52px",
                  color: "#5B5B5B",
                }}
              />
            </div>

            <div className="mt-sm-5 mt-4 text-center text-lg-end  mlsendhelp">
              <button
                className="w-100 modelbtnjoin text-white ftlink text-center border-0 rounded-1 fw600 "
                type="submit"
                style={{
                  maxWidth: "162px ",
                  fontSize: "22px",
                  height: "45px",
                  backgroundColor: "#34C3C9",
                }}
                onClick={handleSend}
              >
                Send
              </button>
            </div>
          </div>
        </div>
        <footer className="bg-[#F2F2F2] border-t border-neutral-200">
          <div className="mx-auto flex max-w-6xl flex-col justify-between gap-6 px-6 py-8 md:flex-row md:items-center">
            <div className="flex flex-col space-y-2 text-sm text-neutral-700">
              <Link to="/terms" className="hover:text-[#34C3C9]">
                Terms of use
              </Link>
              <Link to="/privacy" className="hover:text-[#34C3C9]">
                Privacy Policy
              </Link>
              <Link to="/cookies" className="hover:text-[#34C3C9]">
                Cookies Policy
              </Link>
              <Link to="/help" className="hover:text-[#34C3C9]">
                Help
              </Link>
            </div>
            <div className="flex items-center justify-center md:justify-end">
              <img
                src={require("../components/image/footerlogo.png")}
                alt="Ofellio Logo"
                className="h-8 w-auto"
              />
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Help;
